/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrokerageWorkflowDetail.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/brokerage-workflow-detail";

export class AutogenModelBrokerageWorkflowDetail<RowType extends ModelRow> extends Endpoint<RowType, RowBrokerageWorkflowDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBrokerageWorkflowDetail extends ModelRow<RowBrokerageWorkflowDetailFields> {
	constructor(values?: Partial<RowBrokerageWorkflowDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBrokerageWorkflowDetailFields {
	brokerage_status_code: string;
	can_be_changed_to: string;
	company_id: string;
	end_of_workflow: string;
	id: string;
	parent_id: string;
	sequence: number;
}

